/**
 * @generated SignedSource<<b2728029e7d740cf40d8ed1358f27709>>
 * @relayHash 156aa8d5dc4dba669c243efb6de040e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0304b7a31aceaeb7116aaf279d5b7e7880e4cac6bd8b7dae8869047da807f89f

import type { ConcreteRequest } from 'relay-runtime';
export type useAgentSessionsLiveUpdatesSubscription$variables = {
  accountId: string;
  cloudId: string;
  workspaceAri: string;
};
export type useAgentSessionsLiveUpdatesSubscription$data = {
  readonly convoai_onInboxSessionChanged: {
    readonly session: {
      readonly __typename: "AgentSession";
      readonly agent: {
        readonly accountId: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null;
      readonly agentAccountId: string | null;
      readonly associatedEntities: ReadonlyArray<{
        readonly __typename: "ConfluenceDatabase";
        readonly id: string;
        readonly links: {
          readonly base: string | null;
          readonly webUi: string | null;
        } | null;
        readonly title: string | null;
      } | {
        readonly __typename: "ConfluencePage";
        readonly id: string;
        readonly links: {
          readonly base: string | null;
          readonly webUi: string | null;
        } | null;
        readonly title: string | null;
      } | {
        readonly __typename: "ConfluenceSlide";
        readonly id: string;
        readonly links: {
          readonly base: string | null;
          readonly webUi: string | null;
        } | null;
        readonly title: string | null;
      } | {
        readonly __typename: "ConfluenceWhiteboard";
        readonly id: string;
        readonly links: {
          readonly base: string | null;
          readonly webUi: string | null;
        } | null;
        readonly title: string | null;
      } | {
        readonly __typename: "JiraIssue";
        readonly id: string;
        readonly key: string;
        readonly webUrl: AGG$URL | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null> | null;
      readonly author: {
        readonly accountId: string;
        readonly name: string;
      } | null;
      readonly conversationChannel: {
        readonly createdAt: AGG$Long | null;
        readonly id: string | null;
        readonly interactionChannel: string | null;
        readonly interactionChannelAri: string | null;
        readonly isPinned: boolean | null;
        readonly isPlanning: boolean | null;
        readonly lastAgentMessageId: string | null;
        readonly lastAgentMessageStatus: string | null;
        readonly lastMessage: string | null;
        readonly lastMessageTimestamp: AGG$Long | null;
        readonly lastMessageType: ReadonlyArray<string | null> | null;
        readonly name: string | null;
        readonly pinnedAt: AGG$Long | null;
        readonly readStatus: boolean | null;
        readonly status: string | null;
      } | null;
      readonly convoAiAgentId: string | null;
      readonly expireTime: AGG$DateTime | null;
      readonly id: string | null;
      readonly isRovo: boolean | null;
      readonly lastStateChangeAt: AGG$Long | null;
      readonly state: string | null;
      readonly stateReason: string | null;
      readonly studioAgent: {
        readonly name: string | null;
      } | null;
    } | null;
    readonly sessionAri: string;
    readonly sessionId: string;
  } | null;
};
export type useAgentSessionsLiveUpdatesSubscription = {
  response: useAgentSessionsLiveUpdatesSubscription$data;
  variables: useAgentSessionsLiveUpdatesSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "workspaceAri",
    "variableName": "workspaceAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "sessionAri"
},
v3 = {
  "kind": "ScalarField",
  "name": "sessionId"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "state"
},
v7 = {
  "kind": "ScalarField",
  "name": "stateReason"
},
v8 = {
  "kind": "ScalarField",
  "name": "expireTime"
},
v9 = {
  "kind": "ScalarField",
  "name": "lastStateChangeAt"
},
v10 = {
  "kind": "ScalarField",
  "name": "isRovo"
},
v11 = {
  "kind": "ScalarField",
  "name": "agentAccountId"
},
v12 = {
  "kind": "ScalarField",
  "name": "convoAiAgentId"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "alias": "conversationChannel",
  "concreteType": "AgentConversationChannel",
  "kind": "LinkedField",
  "name": "nativeConversationChannel",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "createdAt"
    },
    {
      "kind": "ScalarField",
      "name": "interactionChannel"
    },
    {
      "kind": "ScalarField",
      "name": "interactionChannelAri"
    },
    (v13/*: any*/),
    {
      "kind": "ScalarField",
      "name": "lastMessage"
    },
    {
      "kind": "ScalarField",
      "name": "lastMessageTimestamp"
    },
    {
      "kind": "ScalarField",
      "name": "lastMessageType"
    },
    {
      "kind": "ScalarField",
      "name": "lastAgentMessageId"
    },
    {
      "kind": "ScalarField",
      "name": "lastAgentMessageStatus"
    },
    {
      "kind": "ScalarField",
      "name": "readStatus"
    },
    {
      "kind": "ScalarField",
      "name": "isPlanning"
    },
    {
      "kind": "ScalarField",
      "name": "isPinned"
    },
    {
      "kind": "ScalarField",
      "name": "pinnedAt"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v16 = {
  "kind": "ScalarField",
  "name": "picture"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "webUrl"
    }
  ],
  "type": "JiraIssue"
},
v18 = {
  "kind": "ScalarField",
  "name": "title"
},
v19 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    (v18/*: any*/),
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v19/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    (v18/*: any*/),
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v19/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    (v18/*: any*/),
    {
      "concreteType": "ConfluenceDatabaseLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v19/*: any*/)
    }
  ],
  "type": "ConfluenceDatabase"
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    (v18/*: any*/),
    {
      "concreteType": "ConfluenceSlideLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v19/*: any*/)
    }
  ],
  "type": "ConfluenceSlide"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAgentSessionsLiveUpdatesSubscription",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConvoAiInboxSessionChanged",
        "kind": "LinkedField",
        "name": "convoai_onInboxSessionChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "AgentSession",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v13/*: any*/),
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "studioAgent",
                "plural": false,
                "selections": [
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "associatedEntities",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v17/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAgentSessionsLiveUpdatesSubscription",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConvoAiInboxSessionChanged",
        "kind": "LinkedField",
        "name": "convoai_onInboxSessionChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "AgentSession",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v15/*: any*/),
                  (v13/*: any*/),
                  (v16/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v15/*: any*/),
                  (v13/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "studioAgent",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v13/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "associatedEntities",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v17/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0304b7a31aceaeb7116aaf279d5b7e7880e4cac6bd8b7dae8869047da807f89f",
    "metadata": {},
    "name": "useAgentSessionsLiveUpdatesSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "2f4fcad5f7502bb9976fd33e48a4d04a";

export default node;
